import { isBrowser } from '@spot-fe/utils';
import { locales } from '@spot-fe/base-ui';
import { ls } from '@sfe/bone-cache';
import { loadJs } from '@spot-fe/utils';
// import { getTmsPath } from './config';
import { getTmsPath } from './config';

export const getBrowserLanguage = () =>
  navigator.language || navigator.browserLanguage || navigator.userLanguage;

export const LOCALE_LS_KEY = 'BYBIT_LANG_KEY';

export const getCookieLanguage = () => {
  const value = ls.get(LOCALE_LS_KEY);
  return value === 'en-US' ? 'en' : value;
};

export const getDefaultLang = () => {
  const browserLang = getBrowserLanguage();
  const cookieLang = getCookieLanguage();
  const lang = cookieLang || browserLang;
  return isBrowser && isSupport(lang) ? lang : 'en';
};

export const isSupport = (locale: string) => locale && locales.includes(locale);

export const loadLocale = async (locale: string) => {
  const path = getTmsPath(locale);
  // console.log('i18n path:', path, window.sfe);
  // window.sfe.locale
  await loadJs(path);
  return window.sfe.locale;
};
